import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SearchLinkModule } from '../search-link/search-link.module';

import { LocationListComponent } from './location-list.component';

@NgModule({
  declarations: [LocationListComponent],
  exports: [LocationListComponent],
  imports: [
    MatIconModule,
    TranslateModule,
    RouterLink,
    MatMenuModule,
    SearchLinkModule,
    NgxSkeletonLoaderModule,
  ],
})
export class LocationListModule {}
